/**
 * NOTE: We prepend a hash to the URLs we do not want crawled by search engines.
 * If you need to add more of these, please check `useHashRouting` and see how we handle
 * routing to #faq, #comments and #rewards as an example to follow.
 */
export const PATHS = {
  PROJECT: '/',
  REWARDS: '/#rewards/',
  FAQ: '/#faq/',
  NEWS: '/news/',
  NEWS_PERMALINK: (params: { slug: string }) => `/news/${params.slug}/`,
  SUPPORTERS: '/supporters/',
  COMMENTS: '/#comments/',
  COMING_SOON: '/coming-soon/',
} as const

type Paths = typeof PATHS
export type StringPaths = { [K in keyof Paths]: Paths[K] extends string ? Paths[K] : never }[keyof Paths]
export type FunctionPaths = {
  [K in keyof Paths]: Paths[K] extends (params: infer PARAMS) => string ? { path: Paths[K]; params: PARAMS } : never
}[keyof Paths]
